<template>
  <div class="one-btn-pop pop">
    <div class="pop-box" :class="{'popBoxUpgrade': popBoxUpgrade}">
      <div class="pop-main">
        <div class="pop-main-top">{{oneBtnPopText.top}}</div>
        <div class="pop-main-test" v-if="!popBoxUpgrade">{{oneBtnPopText.main}}</div>
        <div class="pop-main-test" v-if="popBoxUpgrade" :class="{'en': lang === 'en'}">
          <div>{{$t('device.upgradeTest')}}</div>
          <div>{{$t('device.upgradeTestOne')}}</div>
          <div>{{$t('device.upgradeTestTwo')}}</div>
          <div>{{$t('device.upgradeTestThree')}}</div>
          <div>{{$t('device.upgradeTestFour')}}</div>
        </div>
        <div class="pop-main-bottom">
          <button class="btn-black" @click="closePop">{{oneBtnPopText.btn}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'oneBtnPop',
  props: ['oneBtnPopText', 'popBoxUpgrade'],
  data () {
    return {
      lang: ''
    }
  },
  created () {
    if (this.$i18n.locale === 'en') {
      this.lang = 'en'
    }
  },
  methods: {
    closePop: function () {
      this.$emit('closePop')
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.pop
  .pop-box
    &.popBoxUpgrade
      width 560px
      height 340px
      .pop-main
        .pop-main-top
          top 43px
          font-weight bold
        .pop-main-test
          display block
          height 110px
          padding 0 22px
          top 100px
          line-height 22px
          div
            font-weight bold
          &.en
            height 200px
            top 80px
</style>



// WEBPACK FOOTER //
// src/components/Et/OneBtnPop.vue